import { ObjectItemType } from 'webstudio/src/client/project_content_types';
import { isScanKind } from '_data/helpers/object';
import { EScanDisplayMode, ILoadingProgressLevels } from '_data/types/wsTypes';

interface IGetObjectLoadingProgressParams {
  loadingProgressLevelsObject: ILoadingProgressLevels;
  kind: ObjectItemType;
  scanMode?: EScanDisplayMode;
}

export const getObjectLoadingProgress = ({
  loadingProgressLevelsObject,
  kind,
  scanMode,
}: IGetObjectLoadingProgressParams) => {
  if (isScanKind(kind)) {
    return loadingProgressLevelsObject[scanMode === EScanDisplayMode.MidSurfels ? '1' : '0'];
  }

  return loadingProgressLevelsObject['0'];
};
